export default {
   components: {

   },
   routes: [
      {
         path: '/',
         component: () => import(`./register`),
         name: 'Register'
      }
   ]
}